import { render, staticRenderFns } from "./wait_work_pane.vue?vue&type=template&id=1db21204&scoped=true&"
import script from "./wait_work_pane.vue?vue&type=script&lang=js&"
export * from "./wait_work_pane.vue?vue&type=script&lang=js&"
import style0 from "./wait_work_pane.vue?vue&type=style&index=0&id=1db21204&scoped=true&lang=less&"
import style1 from "./wait_work_pane.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db21204",
  null
  
)

export default component.exports